import { render } from "./Clinicas.vue?vue&type=template&id=c275d9b0&scoped=true"
import script from "./Clinicas.vue?vue&type=script&lang=js"
export * from "./Clinicas.vue?vue&type=script&lang=js"

import "./Clinicas.vue?vue&type=style&index=0&id=c275d9b0&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c275d9b0"]])

export default __exports__